import {StyleSheet} from '@react-pdf/renderer';

import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';

export const tableStyles = StyleSheet.create({
  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  // header row
  tableRowHeader: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: orangeColors[3],
    borderTop: `1pt solid ${orangeColors[5]}`,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
  },
  // body rows
  tableRowEven: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: `${orangeColors[5]}`,
  },
  tableRowOdd: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: orangeColors[4],
  },
  tableCell: {
    padding: 8,
    flex: 3,
  },
  firstColumn: {
    flex: 1.8,
  },
  matchColumn: {
    flex: 1.2,
  },
  tableCellHeader: {
    color: `${greenColors[700]}`,
    fontWeight: 'bold',
  },
  tableRowContent: {
    borderBottom: `1pt solid ${orangeColors[4]}`,
    paddingVertical: 12,
  },
});
